import { HelpCircle } from "lucide-react";
import { AGENT_NAME } from "./agentName";
import { helpOverlayStyles as s } from "./HelpOverlay.styles";
import type { HelpOverlayProps } from "./HelpOverlay.types";

const CAPABILITIES = [
  {
    title: "Summarize conversations",
    description: "Key decisions, action items, and follow-ups from any thread.",
  },
  {
    title: "On-call lookups",
    description: "Find who's covering any department or role right now.",
  },
  {
    title: "Customer support",
    description: "Answer product questions and open a support ticket when you need more help.",
  },
];

const TIPS = [
  "No special commands, just ask naturally.",
  'Name a department like "cardiology" or "ICU" for on-call lookups.',
  "Ask follow-up questions, context carries through the thread.",
  "Use the Summarize button in any conversation to jump straight to a summary.",
];

const COMING_SOON = [
  "Self-scheduling",
  "Clinical protocols",
  "Patient records or EHR access",
  "Medication orders or prescriptions",
  "Scheduling and reminders",
  "Message analytics",
];

export function HelpOverlay({ version }: HelpOverlayProps) {
  return (
    <div className={s.root}>
      <div className={s.header}>
        <HelpCircle className={s.headerIcon} />
        <p className={s.headerTitle}>Help</p>
      </div>
      <div className={s.body}>
        <div className={s.bodyInner}>
          <p className={s.intro}>
            An AI assistant built into TigerConnect. Ask in plain language, {AGENT_NAME} knows your
            context and can act on your behalf.
          </p>
          <div>
            <p className={s.sectionLabel}>What I can do</p>
            <div className={s.capabilitiesList}>
              {CAPABILITIES.map((item) => (
                <div key={item.title} className={s.capabilityItem}>
                  <p className={s.capabilityTitle}>{item.title}</p>
                  <p className={s.capabilityDesc}>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className={s.sectionLabel}>Tips</p>
            <div className={s.tipList}>
              {TIPS.map((tip) => (
                <div key={tip} className={s.tipItem}>
                  <span className={s.tipBullet}>–</span>
                  <p className={s.tipText}>{tip}</p>
                </div>
              ))}
            </div>
          </div>
          <div>
            <p className={s.sectionLabel}>Coming soon</p>
            <div className={s.tipList}>
              {COMING_SOON.map((item) => (
                <div key={item} className={s.tipItem}>
                  <span className={s.tipBullet}>–</span>
                  <p className={s.notSupportedText}>{item}</p>
                </div>
              ))}
            </div>
          </div>
          <div className={s.statusRow}>
            <span className={s.statusDot} />
            <p className={s.statusLabel}>
              {AGENT_NAME}
              {version ? ` · v${version}` : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
